<script>
export default {
  name: 'PushBtn',
  props: {
    title: String,
    label: String,
  },
  methods: {
    click() {
      this.$emit('click');
      this.$emit('remove');
    },
  },
};
</script>

<template lang="pug">
  .push-cancel {{ title }}
    Btn(@click="click") {{ label }}
</template>

<style scoped lang="scss">
.push-cancel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
</style>
